import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';
import TabelasPrecosProdutosPage from './TabelasPrecosProdutosPage';

function ProdutosPage({ empresa, usuario, onVoltar, onSair }) {
  const [produtos, setProdutos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    nome: '',
    caracteristicas: '',
    grupo_id: '',
    unidade_id: '',
    preco: '',
    desc_max: '',
    estoque: '',
    reserva: '',
    taxa_servico: false,
    ativo: true,
    mobile: true,
    balanca: false,
    path_imagem: '',
    fiscal_id: '',
    cean: '',
    ncm: '',
    cest: '',
    orig: '',
    ambiente_id: ''
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });
  const [uploading, setUploading] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [fiscais, setFiscais] = useState([]);
  const [ambientes, setAmbientes] = useState([]);
  const [paginaPrecos, setPaginaPrecos] = useState({ aberta: false, produto: null });

  const PAGE_SIZE = 20;

  const listaOrigem = [
    { value: 0, label: 'Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8' },
    { value: 1, label: 'Estrangeira – importação direta, exceto a indicada no código 6' },
    { value: 2, label: 'Estrangeira – adquirida no mercado interno, exceto a indicada no código 7' },
    { value: 3, label: 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%' },
    { value: 4, label: 'Nacional – cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei n° 288/67 e as Leis nos 8.248/91, 8.387/91, 10.176/2001 e 11.484/2007' },
    { value: 5, label: 'Nacional – mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%' },
    { value: 6, label: 'Estrangeira – importação direta, sem similar, constante em lista de Resolução CAMEX e gás natural' },
    { value: 7, label: 'Estrangeira – adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX e gás natural' },
    { value: 8, label: 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%' }
  ];

  // Função para formatar valor digitado como máscara monetária invertida
  function formatarMascaraDecimal(valor, casas) {
    if (!valor) return '';
    let apenasNumeros = valor.replace(/\D/g, '');
    if (casas === 0) return apenasNumeros.replace(/^0+/, '');
    // Preenche zeros à esquerda se necessário
    if (apenasNumeros.length < casas + 1) {
      apenasNumeros = apenasNumeros.padStart(casas + 1, '0');
    }
    const int = apenasNumeros.slice(0, -casas);
    const dec = apenasNumeros.slice(-casas);
    return Number(int + '.' + dec).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
  }

  // Função para converter decimal do backend para string crua da máscara
  function decimalParaMascara(valor, casas) {
    if (valor === undefined || valor === null) return '';
    const num = Number(valor);
    if (isNaN(num)) return '';
    return Math.round(num * Math.pow(10, casas)).toString();
  }

  // Função para converter decimal do banco para string crua de 3 casas decimais
  function decimalParaMascaraDescMax(valor) {
    if (valor === undefined || valor === null) return '';
    const num = Number(valor);
    if (isNaN(num)) return '';
    return Math.round(num * 1000).toString();
  }

  // Buscar produtos
  const fetchProdutos = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/produtos?empresa_id=${empresa.id}`);
      const data = await res.json();
      setProdutos(Array.isArray(data) ? data : []);
    } catch (err) {
      setErro('Erro ao buscar produtos');
    }
    setLoading(false);
  };

  // Buscar grupos
  const fetchGrupos = async () => {
    try {
      const res = await fetch(`${API_URL}/grupos?empresa_id=${empresa.id}`);
      const data = await res.json();
      setGrupos(Array.isArray(data) ? data : []);
    } catch {}
  };

  // Buscar unidades
  const fetchUnidades = async () => {
    try {
      const res = await fetch(`${API_URL}/unidades?empresa_id=${empresa.id}`);
      const data = await res.json();
      setUnidades(Array.isArray(data) ? data : []);
      console.log('Unidades carregadas:', data);
    } catch (err) {
      console.error('Erro ao buscar unidades:', err);
    }
  };

  // Buscar fiscais
  const fetchFiscais = async () => {
    try {
      const res = await fetch(`${API_URL}/fiscal?empresa_id=${empresa.id}`);
      const data = await res.json();
      setFiscais(Array.isArray(data) ? data : []);
    } catch {}
  };

  // Buscar ambientes
  const fetchAmbientes = async () => {
    try {
      const res = await fetch(`${API_URL}/ambientes?empresa_id=${empresa.id}`);
      const data = await res.json();
      setAmbientes(Array.isArray(data) ? data : []);
    } catch {}
  };

  useEffect(() => {
    fetchProdutos();
    fetchGrupos();
    fetchUnidades();
    fetchFiscais();
    fetchAmbientes();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (produto = null) => {
    if (produto) {
      const unidade = unidades.find(u => String(u.id) === String(produto.unidade_id));
      const casas = unidade ? unidade.casas_decimais : 2;
      setForm({
        ...produto,
        preco: produto.preco ? Math.round(Number(produto.preco) * 100).toString() : '',
        desc_max: decimalParaMascaraDescMax(produto.desc_max),
        estoque: decimalParaMascara(produto.estoque, casas),
        reserva: decimalParaMascara(produto.reserva, casas),
        fiscal_id: produto.fiscal_id || '',
        cean: produto.cean || '',
        ncm: produto.ncm || '',
        cest: produto.cest || '',
        orig: produto.orig === null ? '' : produto.orig,
        ambiente_id: produto.ambiente_id || ''
      });
      setEditando(true);
    } else {
      setForm({
        id: null,
        nome: '',
        caracteristicas: '',
        grupo_id: '',
        unidade_id: '',
        preco: '',
        desc_max: '',
        estoque: '',
        reserva: '',
        taxa_servico: false,
        ativo: true,
        mobile: true,
        balanca: false,
        path_imagem: '',
        fiscal_id: '',
        cean: '',
        ncm: '',
        cest: '',
        orig: '',
        ambiente_id: ''
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      nome: '',
      caracteristicas: '',
      grupo_id: '',
      unidade_id: '',
      preco: '',
      desc_max: '',
      estoque: '',
      reserva: '',
      taxa_servico: false,
      ativo: true,
      mobile: true,
      balanca: false,
      path_imagem: '',
      fiscal_id: '',
      cean: '',
      ncm: '',
      cest: '',
      orig: '',
      ambiente_id: ''
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(f => ({ ...f, [name]: checked }));
    } else {
      if (name === 'preco' || name === 'desc_max') {
        const apenasNumeros = value.replace(/\D/g, '');
        setForm(f => ({ ...f, [name]: apenasNumeros }));
      } else if (name === 'estoque' || name === 'reserva') {
        let apenasNumeros = value.replace(/\D/g, '');
        setForm(f => ({ ...f, [name]: apenasNumeros }));
      } else if (name === 'orig') {
        setForm(f => ({ ...f, [name]: value === '' ? '' : Number(value) }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
      }
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setErro('');
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empresa_id', empresa.id);
    try {
      const res = await fetch(`${API_URL}/upload-produto-imagem`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Erro ao fazer upload');
      const data = await res.json();
      const urlCompleta = "https://conexaopix.com.br/docs" + data.path;
      setForm(f => ({ ...f, path_imagem: urlCompleta }));
    } catch (err) {
      setErro('Erro ao fazer upload da imagem');
    }
    setUploading(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome || !form.grupo_id || !form.unidade_id) {
      setErro('Preencha os campos obrigatórios!');
      return;
    }
    if (uploading) {
      setErro('Aguarde o upload da imagem!');
      return;
    }
    try {
      const unidade = unidades.find(u => u.id === form.unidade_id);
      const casas = unidade ? unidade.casas_decimais : 2;
      const estoque = form.estoque ? (casas === 0 ? Number(form.estoque) : Number(form.estoque) / Math.pow(10, casas)) : 0;
      const reserva = form.reserva ? (casas === 0 ? Number(form.reserva) : Number(form.reserva) / Math.pow(10, casas)) : 0;
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/produtos/${form.id}` : `${API_URL}/produtos`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          caracteristicas: form.caracteristicas,
          grupo_id: form.grupo_id,
          unidade_id: form.unidade_id,
          preco: form.preco ? (Number(form.preco) / 100) : 0,
          desc_max: form.desc_max ? (Number(form.desc_max) / 1000) : 0,
          estoque,
          reserva,
          taxa_servico: form.taxa_servico,
          ativo: form.ativo,
          mobile: form.mobile,
          balanca: form.balanca,
          path_imagem: form.path_imagem,
          fiscal_id: form.fiscal_id || null,
          cean: form.cean || '',
          ncm: form.ncm || '',
          cest: form.cest || '',
          orig: form.orig === '' ? null : Number(form.orig),
          ambiente_id: form.ambiente_id || ''
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar produto');
      fecharModal();
      fetchProdutos();
    } catch (err) {
      setErro('Erro ao salvar produto');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/produtos/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchProdutos();
    } catch {
      setErro('Erro ao remover produto');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const produtosFiltrados = produtos.filter(p =>
    (p.nome || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    String(p.id).includes(pesquisa) ||
    (p.codigo || '').toLowerCase().includes(pesquisa.toLowerCase())
  );

  const totalPaginas = Math.ceil(produtosFiltrados.length / PAGE_SIZE);
  const produtosPaginados = produtosFiltrados.slice((pagina - 1) * PAGE_SIZE, pagina * PAGE_SIZE);

  if (paginaPrecos.aberta) {
    return <TabelasPrecosProdutosPage empresa={empresa} usuario={usuario} onVoltar={() => setPaginaPrecos({ aberta: false, produto: null })} onSair={onSair} produtoSelecionado={paginaPrecos.produto} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Produtos</h2>
        <div className="mb-6 flex justify-start">
          <input
            type="text"
            value={pesquisa}
            onChange={e => { setPesquisa(e.target.value); setPagina(1); }}
            placeholder="Pesquisar por id, código ou nome..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) :
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {produtosPaginados.map(p => (
                <div key={p.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                  {p.path_imagem && (
                    <img src={p.path_imagem} alt={p.nome} className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                  )}
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold text-blue-800 text-lg">{p.nome}</span>
                    <div className="flex space-x-2">
                      <button onClick={() => abrirModal(p)} title="Editar" className="text-blue-600 hover:text-blue-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                      </button>
                      <button onClick={() => handleDelete(p.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                    </div>
                  </div>
                  <div className="text-gray-700 mb-1"><b>Características:</b> {p.caracteristicas}</div>
                  <div className="text-gray-700 mb-1"><b>Grupo:</b> {grupos.find(g => g.id === p.grupo_id)?.nome || '-'}</div>
                  <div className="text-gray-700 mb-1"><b>Unidade:</b> {unidades.find(u => u.id === p.unidade_id)?.sigla || '-'}</div>
                  <div className="text-gray-700 mb-1"><b>Preço:</b> {Number(p.preco).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                  <div className="text-gray-700 mb-1"><b>Desc. Máx %:</b> {Number(p.desc_max).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</div>
                  <div className="text-gray-700 mb-1"><b>Estoque:</b> {(() => {
                    const unidade = unidades.find(u => String(u.id) === String(p.unidade_id));
                    const casas = unidade ? unidade.casas_decimais : 2;
                    if (p.estoque === undefined || p.estoque === null) return '-';
                    return Number(p.estoque).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
                  })()}</div>
                  <div className="text-gray-700 mb-1"><b>Reserva:</b> {(() => {
                    const unidade = unidades.find(u => String(u.id) === String(p.unidade_id));
                    const casas = unidade ? unidade.casas_decimais : 2;
                    if (p.reserva === undefined || p.reserva === null) return '-';
                    return Number(p.reserva).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
                  })()}</div>
                  <div className="text-gray-700 mb-1"><b>Taxa Serviço:</b> {p.taxa_servico ? 'Sim' : 'Não'}</div>
                  <div className="text-gray-700 mb-1"><b>Ativo:</b> {p.ativo ? 'Sim' : 'Não'}</div>
                  <div className="text-gray-700 mb-1"><b>Mobile:</b> {p.mobile ? 'Sim' : 'Não'}</div>
                  <div className="flex justify-between items-center text-gray-700 mb-1">
                    <span><b>Balança:</b> {p.balanca ? 'Sim' : 'Não'}</span>
                    <span className="text-xs text-gray-500 font-bold">ID: {p.id}</span>
                  </div>
                  <div className="flex justify-center space-x-4 mt-2 pt-2 border-t border-blue-200">
                    {/* Ícone Barras (código de barras) */}
                    <button title="Barras" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <rect x="2" y="4" width="2" height="16"/>
                        <rect x="6" y="7" width="1.5" height="10"/>
                        <rect x="9" y="4" width="1" height="16"/>
                        <rect x="12" y="7" width="2" height="10"/>
                        <rect x="16" y="4" width="1.5" height="16"/>
                        <rect x="19.5" y="7" width="1" height="10"/>
                      </svg>
                    </button>
                    {/* Ícone Preços (etiqueta) */}
                    <button title="Preços" className="text-blue-600 hover:text-blue-900" onClick={() => setPaginaPrecos({ aberta: true, produto: p })}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M7 7l10 10M7 17L17 7"/>
                        <rect x="3" y="3" width="18" height="18" rx="4"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                      </svg>
                    </button>
                    {/* Ícone Adicionais (cubo) */}
                    <button title="Adicionais" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <rect x="3" y="7" width="18" height="10" rx="2"/>
                        <rect x="7" y="3" width="10" height="18" rx="2"/>
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
              {produtosPaginados.length === 0 && (
                <div className="col-span-full text-center py-8 text-gray-500">Nenhum produto encontrado.</div>
              )}
            </div>
            {totalPaginas > 1 && (
              <div className="flex justify-center items-center mt-8 mb-2 w-full">
                {Array.from({ length: totalPaginas }, (_, i) => (
                  <button
                    key={i + 1}
                    className={`w-10 h-10 flex items-center justify-center rounded transition font-semibold border mx-0.5
                      ${pagina === i + 1 ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
                    onClick={() => setPagina(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            )}
          </>
        }
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Produto"
        >
          +
        </button>
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Produto' : 'Novo Produto'}</h3>
              <form onSubmit={handleSubmit}>
                {/* Card Informações */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Informações</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Produto*</label>
                    <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={100} required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Características</label>
                    <input name="caracteristicas" value={form.caracteristicas} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={255} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Grupo*</label>
                    <select name="grupo_id" value={form.grupo_id} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {grupos.map(g => <option key={g.id} value={g.id}>{g.nome}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Unidade*</label>
                    <select name="unidade_id" value={form.unidade_id} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {unidades.map(u => <option key={u.id} value={u.id}>{u.sigla}</option>)}
                    </select>
                  </div>
                  <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Ambiente de Impressão</label>
                      <select name="ambiente_id" value={form.ambiente_id || ''} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                        <option value="">Selecione...</option>
                        {ambientes.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
                      </select>
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Imagem</label>
                      <input type="file" accept="image/*" onChange={handleFileChange} className="border rounded px-3 py-2 w-full" />
                      {form.path_imagem && (
                        <div className="mt-2">
                          <img src={form.path_imagem} alt="Preview" className="w-20 h-20 object-cover rounded shadow border" />
                        </div>
                      )}
                  </div>
                  </div>
                </div>

                {/* Card Adicionais */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-3">Adicionais</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Preço*</label>
                    <input name="preco"
                      value={formatarMascaraDecimal(form.preco, 2)}
                      onChange={handleChange}
                      className="border rounded px-3 py-2 w-full"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Desc. Max. %</label>
                    <input name="desc_max"
                      value={(() => {
                        if (!form.desc_max) return '';
                        // Garante sempre 3 casas decimais
                        let num = Number(form.desc_max) / 1000;
                        return num.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
                      })()}
                      onChange={e => {
                        // Aceita apenas números
                        let v = e.target.value.replace(/[^0-9]/g, '');
                        setForm(f => ({ ...f, desc_max: v }));
                      }}
                      className="border rounded px-3 py-2 w-full"
                      placeholder="0,000"
                      maxLength={6}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Estoque</label>
                      <input name="estoque"
                        value={(() => {
                          const unidade = unidades.find(u => String(u.id) === String(form.unidade_id));
                          const casas = unidade ? unidade.casas_decimais : 2;
                          return formatarMascaraDecimal(form.estoque, casas);
                        })()}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Reserva</label>
                      <input name="reserva"
                        value={(() => {
                          const unidade = unidades.find(u => String(u.id) === String(form.unidade_id));
                          const casas = unidade ? unidade.casas_decimais : 2;
                          return formatarMascaraDecimal(form.reserva, casas);
                        })()}
                        onChange={handleChange}
                        className="border rounded px-3 py-2 w-full" />
                  </div>
                    <div className="md:col-span-2">
                      <div className="flex flex-wrap gap-4">
                    <label className="inline-flex items-center">
                      <input name="taxa_servico" type="checkbox" checked={form.taxa_servico} onChange={handleChange} className="mr-2" />
                      Taxa Serviço
                    </label>
                        <label className="inline-flex items-center">
                          <input name="balanca" type="checkbox" checked={form.balanca} onChange={handleChange} className="mr-2" />
                          Balança
                    </label>
                    <label className="inline-flex items-center">
                      <input name="ativo" type="checkbox" checked={form.ativo} onChange={handleChange} className="mr-2" />
                      Ativo
                    </label>
                    <label className="inline-flex items-center">
                      <input name="mobile" type="checkbox" checked={form.mobile} onChange={handleChange} className="mr-2" />
                      Mobile
                    </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card Fiscais */}
                <div className="bg-blue-50 rounded-lg shadow p-4 border border-blue-200 mb-4">
                  <h4 className="font-bold text-blue-700 mb-2">Fiscais</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Imposto</label>
                      <select name="fiscal_id" value={form.fiscal_id || ''} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                        <option value="">Selecione...</option>
                        {fiscais.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CEAN</label>
                      <input name="cean" value={form.cean || ''} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={14} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">NCM</label>
                      <input name="ncm" value={form.ncm || ''} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={8} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CEST</label>
                      <input name="cest" value={form.cest || ''} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={7} />
                  </div>
                  <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Origem</label>
                      <select name="orig" value={form.orig === '' ? '' : form.orig} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                        <option value="">Selecione...</option>
                        {listaOrigem.map(o => (
                          <option key={o.value} value={o.value}>
                            {o.label}
                          </option>
                        ))}
                      </select>
                      </div>
                  </div>
                </div>

                {erro && <div className="text-red-600 mb-4">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-50">Cancelar</button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Salvar</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <h3 className="text-xl font-bold text-blue-700 mb-4">Confirmar Exclusão</h3>
              <p>Tem certeza que deseja excluir este produto?</p>
              <div className="flex justify-end space-x-2 mt-6">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProdutosPage; 